import { ModuleWithProviders } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AspirinaComponent } from './pages/aspirina/aspirina.component';
import { Babysec } from './pages/babysec/babysec';
import { BabySecset } from './pages/babysecset/babysecset';
import { BoticaComponent } from './pages/botica/botica.component';
import { Consumo } from './pages/consumo/consumo';
import { CotidianComponent } from './pages/cotidian/cotidian.component';
import { Cyber } from './pages/cyber/cyber';
import { Dermo } from './pages/dermo/dermo';
import { Dermo20 } from './pages/dermo20/dermo20';
import { Ensure } from './pages/ensure/ensure';
import { Redoxito } from './pages/redoxito/redoxito';
import { Secos } from './pages/secos/secos';
import { Tenna } from './pages/tenna/tenna';
import { Farma } from './pages/farma/farma';
import { Huggies } from './pages/huggies/huggies';
import { InkaclubComponent } from './pages/inkaclub/inkaclub.component';
import { Ladysoft } from './pages/ladysoft/ladysoft';
import { Mondsub } from './pages/mondsub/mondsub';
import { Nutricion } from './pages/nutricion/nutricion';
import { PromoAdulto } from './pages/promoadulto/promoadulto';
import { PromoBabysec } from './pages/promobabysec/promobabysec';
import { PromoPlenitud } from './pages/promoplenitud/promoplenitud';
import { EucerinComponent } from './pages/eucerin/eucerin.component';
import { MultimarcaNutricionComponent } from './pages/multimarca-nutricion/multimarca-nutricion.component';
import { HomeSorteosComponent } from './pages/home-sorteos/home-sorteos.component';
import { CapilatisComponent } from './pages/capilatis/capilatis.component';
import { NotFoundComponent } from './pages/not-found/not-found.component';
import { SorteoMilsolesComponent } from './pages/sorteo-milsoles/sorteo-milsoles.component';
import { SorteoAgoraComponent } from './pages/sorteo-agora/sorteo-agora.component';
import { SorteoNinetComponent } from './pages/sorteo-ninet/sorteo-ninet.component';
import { SuplementoAdultoComponent } from './pages/suplemento-adulto/suplemento-adulto.component';


export const routes: Routes = [
  { path: '', component: HomeSorteosComponent, pathMatch: 'full' },
  { path: 'redoxitos', component: Redoxito },
  { path: 'secos', component: Secos },
  { path: 'tena', component: Tenna },
  { path: 'concurso', component: Mondsub },
  { path: 'dermo20', component: Dermo20 },
  { path: 'farma', component: Farma },
  { path: 'cyber', component: Cyber },
  { path: 'ensure', component: Ensure },
  { path: 'consumo', component: Consumo },
  { path: 'nutricion', component: Nutricion },
  { path: 'dermo', component: Dermo },
  { path: 'sorteo-old', component: Ladysoft },
  { path: 'plenitud', component: PromoPlenitud },
  { path: 'babysec-old', component: PromoBabysec },
  { path: 'babysec', component: Babysec },
  { path: 'adultoh', component: PromoAdulto },
  { path: 'huggies', component: Huggies },
  { path: 'babysec-set', component: BabySecset },
  { path: 'boticas', component: BoticaComponent },
  { path: 'inkaclub', component: InkaclubComponent },
  { path: 'cotidian', component: CotidianComponent },
  { path: 'aspirina', component: AspirinaComponent },
  { path: 'eucerinbaby', component: EucerinComponent },
  { path: 'multimarcanutricion', component: MultimarcaNutricionComponent },
  { path: 'capilatis', component: CapilatisComponent },
  { path: 'milsolesdiarios', component: SorteoMilsolesComponent },
  { path: 'sorteo-agora', component: SorteoAgoraComponent },
  { path: 'suplemento-adulto', component: SuplementoAdultoComponent},
  //{ path: 'ninet', component: SorteoNinetComponent },
  { path: 'not-found', component: NotFoundComponent},
  { path: '**', pathMatch: 'full', redirectTo: 'not-found' }

];

export const routing: ModuleWithProviders = RouterModule.forRoot(routes, { useHash: false });
